import React from 'react';
import Box from '@material-ui/core/Box';
import AppRadio from '../../components/AppRadio';
import Typography from '@material-ui/core/Typography';
import CurrencyFormat from 'react-currency-format';
import { makeStyles } from '@material-ui/core/styles';
import theme from '../../modules/theme';
import { useDispatch, useSelector } from 'react-redux';
import { setFulfillmentSelected } from '../../redux/actions/fulfillments';
import { SELECTOR_FULFILLMENT_SELECTED } from '../../redux/selectors/fulfillments';

const useStyles = makeStyles({
  itemCard: {
    border: '0.5px solid rgba(122,122,122,0.6)',
    borderRadius: 10,
  },
  info: {
    fontWeight: 400,
    fontSize: '.8rem',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    textTransform: 'capitalize',
  },
});

export function ViewServiceDeliveryItem({ fulfillment }) {
  const selected = useSelector(SELECTOR_FULFILLMENT_SELECTED);

  const classes = useStyles();
  const dispatch = useDispatch();

  function getDescription(fulfillmen) {
    switch (true) {
      case fulfillmen.status === 'failed':
        return `${fulfillmen.respuesta} - envia colvanes`;
      case fulfillmen.fulfillmentCompany?.fulfillment_company_id === 2:
        return `Envío ${fulfillmen.send_description}`
      default:
        return fulfillmen?.fulfillmentCompany?.description;
    }
  }

  function handleChangeFulfillmentCost({ service_code, ...c }) {
    dispatch(setFulfillmentSelected(service_code));
  }

  return fulfillment.status === 'failed' ? (
    <div />
  ) : (
    <Box display="flex" flexDirection="column" className={classes.itemCard} mb={1}>
      {fulfillment?.status === 'failed' && <Box className={classes.disabled} />}
      <Box display="flex" className={classes.content}>
        <Box display="flex" alignItems={'center'}>
          <AppRadio
            disabled={fulfillment.status === 'failed'}
            checked={fulfillment.service_code === selected}
            onClick={() => handleChangeFulfillmentCost(fulfillment)}
            className={classes.radio}
            color="default"
            inputProps={{ 'aria-label': 'E' }}
            size="small"
          />
        </Box>
        <Box display="flex" flexDirection="column" className={classes.info}>
          <Typography variant="inherit">{fulfillment?.fulfillmentCompany?.name}</Typography>
          <Typography variant="inherit">{getDescription(fulfillment)}</Typography>
          <div style={{ display: 'flex', gap: 4 }}>
            <CurrencyFormat
              value={fulfillment?.price}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              renderText={(value) => (
                <Typography variant="inherit">{value === '$0' ? '$0 - Envío Gratis' : value}</Typography>
              )}
            />
            {fulfillment?.discount > 0 && (
              <CurrencyFormat
                value={fulfillment?.discount + fulfillment?.price}
                displayType={'text'}
                thousandSeparator={true}
                prefix={'$'}
                renderText={(value) => (
                  <Typography variant="inherit"> - <del>{value}</del></Typography>
                )}
              />
            )}
          </div>
        </Box>
      </Box>
    </Box>
  );
}
